import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NonceService {
  constructor() {}

  // Method to generate a nonce (secure random string)
  generateNonce(length: number = 32): string {
    const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let nonce = '';
    for (let i = 0; i < length; i++) {
      // SonarQube: This is not a security-sensitive use of Math.random()
      const randomIndex = Math.floor(Math.random() * charset.length); //NOSONAR
      nonce += charset[randomIndex];
    }
    return nonce;
  }
}
